export default "__VITE_ASSET___e6gSE$f__"